import { render, staticRenderFns } from "./PaymentJournal.vue?vue&type=template&id=b7ed3d20&"
import script from "./PaymentJournal.vue?vue&type=script&lang=js&"
export * from "./PaymentJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports